import Constants from '@/Constants';
import { AutomaticEnrollRule } from '@/models/AutomaticEnroll';
import { useGet } from './useGet';

const getKey = (classId?: number): string | null => {
    if (!classId) {
        return null;
    }
    return `${Constants.LMS_AUTOMATIC_ENROLLMENT_URI}?programClassId=${classId}`;
};

export const useAutomaticEnrollRule = (classId: number) => {
    const { data: response, loading, revalidateResult } = useGet<AutomaticEnrollRule[]>(getKey(classId));
    return { response, loading, revalidateResult };
};
